import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { setSearchEdit } from '../../../redux/actions';

import analyticService from '../../../services/analytics';
import { getClass } from '../../../utils/component-helpers';
import { session } from '../../../services/session';
import checkmarkSVG from '../../../images/icons/icon-checkmark-black.svg';
import liveSVG from '../../../images/icons/live.svg';
import dotSVG from '../../../images/icons/dot.svg';
import grayDotSVG from '../../../images/icons/dot-gray.svg';
import { dateService } from '../../../services/date';
import megatableService from './megatable-service';
import { formatValue, displayNetworks } from '../common/utils';
import {
  getRowClasses,
  getIntervalColorAndIcon,
  formatCurrencyStringToNumber,
} from '../../admin/bid-center/utils';
import Tooltip from '../../misc/tooltip';
import ProductPreview from './product-preview';
import FormHelper from '../../misc/form-helper';

import linkoutIcon from '../../../images/icons/linkout.svg';
import editSmartlinkIcon from '../../../images/icons/editor.png';
import './stat-row.scss';

const statusIcons = {
  Live: liveSVG,
  Upcoming: dotSVG,
  Completed: checkmarkSVG,
  Paused: grayDotSVG,
};

class StatRow extends Component {
  constructor(props) {
    super(props);

    this.service = megatableService;
    this.AnalyticService = analyticService;

    this.statTooltip = null;
    this.editNode = null;

    this.state = {
      showProductPreview: false,
    };
  }

  addTooltip(el, type, networks, text) {
    if (el) {
      if (type === 'link-out') {
        return new Tooltip(el, { text: 'Go to Article', size: 4 });
      }
      if (type === 'abbreviated') {
        return new Tooltip(el, { text, size: 1 });
      }
      if (type === 'edit-smartlink') {
        return new Tooltip(el, { text: 'Edit Link', size: 3 });
      }
      if (
        type === 'smartlinks' &&
        !['top-article', 'merchantArticle', 'merchantRecommendation'].includes(this.props.statType)
      ) {
        return new Tooltip(el, {
          text: 'See Smartlinks in this Article',
          size: 220,
          fixedSize: true,
        });
      }
      if (type === 'bam_link_merchant_product_name') {
        return new Tooltip(el, {
          text: 'See products users purchased after clicking on this link',
          size: 220,
          fixedSize: true,
        });
      }
      if (type === 'product_name' && this.props.data.edit_ids) {
        return new Tooltip(el, {
          text: 'See stories that feature this product',
          size: 200,
          fixedSize: true,
        });
      }
      if (type === 'affiliate_networks' && networks && networks.length > 1) {
        return new Tooltip(el, { text: displayNetworks(networks, 'tooltip'), size: 1 });
      }
      if (type === 'pilot_rate') {
        const propsCpc = this.props.data.cpc_clicks_percent;
        const cpcClicksPercent = propsCpc > 1 ? Math.round(propsCpc) : propsCpc;
        return new Tooltip(el, {
          text: `${cpcClicksPercent}% of Clicks are Pilot Rates`,
          size: 2,
        });
      }
      if (type === 'merchant_article') {
        return new Tooltip(el, {
          text: 'Published in the last 7 days',
          size: 2,
        });
      }
      if (type === 'click_through_rate' || type === 'product_conversion_rate') {
        return new Tooltip(el, {
          text: 'Insufficient data due to low click volume',
          size: 200,
          fixedSize: true,
        });
      }
      if (type === 'impressions') {
        return new Tooltip(el, {
          text: 'Impression data is unavailable for this publisher',
          size: 200,
          fixedSize: true,
        });
      }
      if (
        ['daily_budget_amount', 'monthly_budget_amount'].includes(type) &&
        this.props.statType !== 'merch-ed-overview'
      ) {
        return new Tooltip(el, {
          text:
            'Update budget data by changing value and hitting the enter key. ' +
            'Yellow outline indicates changed but not saved value, green indicates ' +
            'that the value has been updated, and red indicates that the budget update failed.',
          size: 200,
          fixedSize: true,
        });
      }
    }
  }

  getRedirectData() {
    let header;
    let gaLabel;
    let linkName;
    let redirectPath;
    let search;
    const pubId = this.props.match.params.publisherId;
    const urlParams = new URLSearchParams(this.props.location.search);
    const queryParams = this.getQueryParams(urlParams);
    const currentPath = this.props.location.pathname;

    if (this.props.tableName === 'Links') {
      header = 'Products purchased for';
      linkName = this.props.data.bam_link_merchant_product_name;
      gaLabel = `Links Drilldown to Products ${linkName}`;
      redirectPath = `/v2/publisher/${pubId}/megatables/products`;
      search =
        `?auction_id=${this.props.data.auction_id}&` +
        `date_from=${urlParams.get('date_from')}&date_to=${urlParams.get('date_to')}`;
    } else if (this.props.tableName === 'Stories') {
      header = 'Links featured in';
      linkName = this.props.data.edit_name;
      gaLabel = `Stories Drilldown to Smartlinks ${linkName}`;
      redirectPath = `/v2/publisher/${pubId}/megatables/smartlinks`;
      search =
        `?edit_id=${this.props.data.edit_id}&` +
        `date_from=${urlParams.get('date_from')}&date_to=${urlParams.get('date_to')}`;
    } else if (this.props.tableName === 'Products Purchased') {
      header = 'Stories featuring';
      linkName = this.props.data.product_name;
      gaLabel = `Products Drilldown to Articles ${linkName}`;
      redirectPath = `/v2/publisher/${pubId}/megatables/articles`;
      search =
        `?edit_ids=${this.props.data.edit_ids}&` +
        `date_from=${urlParams.get('date_from')}&date_to=${urlParams.get('date_to')}`;
    }

    return {
      header,
      gaLabel,
      linkName,
      redirectPath,
      currentPath,
      search,
      queryParams,
    };
  }

  getQueryParams(urlParams) {
    const params = {};
    const paramKeys = [
      'date_from',
      'date_to',
      'order_by',
      'direction',
      'granularity',
      'graphed_ids',
      'networks',
      'edit_id',
      'auction_id',
    ];

    paramKeys.forEach(key => {
      let value = urlParams.get(key);

      if (key === 'edit_id') value = parseInt(value);

      if (value) {
        params[key] = value;
      }
    });

    return params;
  }

  redirectToPage() {
    if (this.props.statType === 'merchantArticleSearch') {
      analyticService.trackEvent(
        'Article Search',
        'Click',
        `${this.props.data.edit_name} drilldown to products`,
      );
      return this.props.setSearchEdit({
        id: this.props.data.edit_id,
        name: this.props.data.edit_name,
        url: this.props.data.edit_url,
      });
    }
    if (this.props.tableName === 'Products Purchased' && !this.props.data.edit_ids) return;
    if (this.props.tableName === 'Stories') {
      if (!this.props.data.edit_id || this.disableLinks) return;
      this.statTooltip.hideTooltip();
    }
    if (['top-article', 'merchantArticle', 'merchantRecommendation'].includes(this.props.statType))
      return;

    const crumbData = this.getRedirectData();
    this.AnalyticService.trackEvent('Mega Tables', 'Click', crumbData.gaLabel);
    this.service.breadcrumbClicked = true;

    this.service.breadcrumbs.push({
      name: crumbData.linkName,
      path: crumbData.redirectPath,
      search: crumbData.search,
      header: crumbData.header,
    });
    this.props.history.push({
      pathname: crumbData.redirectPath,
      search: crumbData.search,
    });
  }

  onEditUrlClicked() {
    const gaLabel = `Hyperlink on ${this.props.tableName} Table ${this.props.data.edit_url}`;
    this.AnalyticService.trackEvent('Mega Tables', 'Click', gaLabel);
  }

  updateBudget(e) {
    if (e) e.preventDefault();
    let target;
    let value;
    if (this.props.statType === 'merch-ed-overview') {
      const budgetType = this.props.budgetRowId.split(',')[1];
      target = budgetType === 'monthly_budget_amount' ? this.monthlyInputNode : this.dailyInputNode;
      // '.replace' would only replace the first instance
      value = target.value
        .split('')
        .reduce((acc, curr) => (['$', ','].includes(curr) ? acc : acc + curr), '');
    } else {
      target = e.target.querySelector('input');
      value = target.value;
    }
    const date = new URLSearchParams(this.props.location.search).get('date_from');

    this.props
      .updateBudget(
        this.props.data.merch_id,
        parseFloat(value).toFixed(2),
        target.name,
        this.props.data.budget_id,
        date,
      )
      .then(() => {
        target.classList.replace('pending', 'success'); // On success, color input box green
      })
      .catch(() => {
        target.classList.replace('pending', 'failure'); // On fail, color input box red
      });
  }

  updateBudgetCell(e) {
    e.target.classList.remove('success', 'failure', 'pending');
    if (e.target.value !== this.props.data[e.target.name]) {
      e.target.classList.add('pending'); // On value change, color input box yellow
    }
    if (this.props.statType === 'merch-ed-overview') {
      let newValue = e.target.value
        .split('')
        .reduce((acc, curr) => (/\d/g.test(curr) ? acc + curr : acc), '');
      if (parseInt(newValue) > 9999999) {
        newValue = 9999999;
        newValue = newValue.toString();
      }
      e.target.value = formatValue(newValue, 'currency', e.target.name);
    }
  }

  /* Render helper */
  formatDisplay(columnObj) {
    const { data } = this.props;
    let value = data[columnObj.name];

    // Sanitize product names that are null or product IDs (integer)
    if (
      this.props.statType === 'product' &&
      columnObj.name === 'product_name' &&
      (value === null || parseInt(value).toString() === value.toString())
    ) {
      value = '(Not available)';
    }

    return formatValue(value, columnObj.type, columnObj.name, true);
  }

  formatRoiValues(roiValues) {
    // Need to parse '-' ROI values to null to calculate the color/icon of the arrow indicator
    return roiValues.map(val => {
      return val === '-' ? null : parseFloat(val);
    });
  }

  // TODO: Clean this up
  getColumnHtml(columnObj, index) {
    if (!columnObj.selected || columnObj.exclude) return null;

    // Bypass this function if parent provided custom formatter and got result
    if (this.props.columnFormatter) {
      const formatterResult = this.props.columnFormatter(columnObj, this.props, this.props.history);
      if (formatterResult) return formatterResult;
    }

    const timeDiff = dateService.subtractDates(
      this.props.data.event_date,
      dateService.getCurrentDateTime(),
      'day',
    );
    const newBadge =
      timeDiff <= 7 && this.props.statType === 'top-article' && columnObj.name === 'event_date' ? (
        <span className="badge new" ref={node => this.addTooltip(node, 'merchant_article')}>
          New
        </span>
      ) : null;

    const badge =
      this.props.data.cpc_clicks_percent >= 5 && this.props.statType === 'merchant' ? (
        <span className="badge cpc" ref={node => this.addTooltip(node, 'pilot_rate')}>
          Pilot Rates
        </span>
      ) : null;

    let columnContent;

    if (columnObj.name === 'field_name') {
      columnContent = (
        <a
          href={`admin/feed-comparison/${this.props.match.params.merchantId}/
						${this.props.data.field_name}/`}
        >
          {this.formatDisplay(columnObj)}
        </a>
      );
    } else if (
      columnObj.name === 'bam_link_merchant_product_name' ||
      columnObj.name === 'product_name'
    ) {
      const disableLink = columnObj.name === 'product_name' && !this.props.data.edit_ids;
      columnContent = (
        <span
          onClick={this.redirectToPage.bind(this)}
          className={`product_name${disableLink ? ' disabled' : ''}`}
        >
          {this.formatDisplay(columnObj)}
        </span>
      );
    } else if (columnObj.name === 'merchant_name' && this.props.statType === 'merchant') {
      columnContent = (
        <>
          <span className="merchant_name">{this.formatDisplay(columnObj)}</span>
        </>
      );
    } else if (
      this.props.statType === 'merchant-performance-overview' &&
      columnObj.name === 'name' &&
      this.props.data.status !== 'Upcoming' &&
      !(
        this.props.data.status === 'Paused' &&
        dateService.compareDateWithToday(this.props.data.datetime_start) === 1
      )
    ) {
      const id = this.props.data.strategy_id;
      columnContent = (
        <span
          className="strategy-link-out"
          ref={node => this.addTooltip(node, 'abbreviated', null, this.props.data[columnObj.name])}
          onClick={() => {
            this.props.history.push(
              `/v2/merchant/${session.orgId}/campaign-performance/${id}/overview`,
            );
          }}
        >
          {this.props.data[columnObj.name] || '-'}
        </span>
      );
    } else if (
      this.props.statType === 'merchant-performance-overview' &&
      ['labels', 'name'].includes(columnObj.name)
    ) {
      columnContent = (
        <span
          ref={node => this.addTooltip(node, 'abbreviated', null, this.props.data[columnObj.name])}
        >
          {this.props.data[columnObj.name] || '-'}
        </span>
      );
    } else if (columnObj.name === 'datetime_start' || columnObj.name === 'datetime_end') {
      if (this.props.statType === 'merchant-performance-overview') {
        let additionalContent;
        if (this.props.data[columnObj.name] && this.props.data.status === 'Live') {
          const statDate = dateService.dateFromStr(
            columnObj.name === 'datetime_start'
              ? this.props.data.datetime_start
              : this.props.data.datetime_end,
          );
          const diff = Math.abs(dateService.timeFrom(statDate, 'days'));
          additionalContent = !['Ongoing', 'No End Date'].includes(
            this.props.data[columnObj.name],
          ) ? (
            <span className="diff">
              {`${diff} days ${columnObj.name === 'datetime_start' ? 'passed' : 'left'}`}
            </span>
          ) : null;
        }

        if (this.props.data.status === 'Upcoming' && columnObj.name === 'datetime_start') {
          additionalContent = <span className="diff">Not Started Yet</span>;
        }

        columnContent = (
          <>
            <span>{this.props.data[columnObj.name]}</span>
            {additionalContent}
          </>
        );
      }
    } else if (['daily_budget_amount', 'monthly_budget_amount'].includes(columnObj.name)) {
      if (this.props.statType === 'merch-ed-overview') {
        if (!('merchant_roi_goals' in this.props.data)) {
          columnContent = <p>-</p>;
        } else {
          const nodeName = `${
            columnObj.name === 'monthly_budget_amount' ? 'monthly' : 'daily'
          }InputNode`;

          columnContent = (
            <form onSubmit={this.updateBudget.bind(this)}>
              <input
                ref={node => (this[nodeName] = node)}
                type="string"
                defaultValue={formatValue(
                  parseFloat(this.props.data[columnObj.name]),
                  columnObj.type,
                  columnObj.name,
                  true,
                )}
                name={columnObj.name}
                className={`${columnObj.name} input`}
                onChange={this.updateBudgetCell.bind(this)}
              />
            </form>
          );
        }
      } else {
        columnContent = (
          <form onSubmit={this.updateBudget.bind(this)}>
            <input
              type="number"
              max="9999999.99"
              defaultValue={parseFloat(this.props.data[columnObj.name]).toFixed(2)}
              name={columnObj.name}
              className={`${columnObj.name} input`}
              onChange={this.updateBudgetCell.bind(this)}
              step=".01"
            />
          </form>
        );
      }
    } else if (columnObj.name === 'is_winning') {
      columnContent = <span className={`${this.props.data[columnObj.name] ? 'checkmark' : ''}`} />;
    } else if (columnObj.name === 'status') {
      const statusType = this.props.data[columnObj.name];
      columnContent = (
        <>
          <img
            className={`status-icon ${statusType}`}
            alt="status icon"
            src={statusIcons[statusType]}
          />
          {statusType}
        </>
      );
    } else if (['merchant-performance-overview'].includes(this.props.statType)) {
      columnContent = this.props.data[columnObj.name];
    } else {
      columnContent = this.formatDisplay(columnObj);
    }

    if (columnObj.name === 'affiliate_networks') {
      return (
        <div
          key={index}
          className={`column ${columnObj.name}`}
          ref={node => this.addTooltip(node, columnObj.name, this.props.data.affiliate_networks)}
        >
          <p className={displayNetworks(this.props.data.affiliate_networks, 'label')}>
            {displayNetworks(this.props.data.affiliate_networks, 'label')}
          </p>
        </div>
      );
    }

    const editSmartlink =
      this.props.tableName === 'Links' ? (
        <span
          className="edit-smartlink"
          onClick={() => this.props.toggleModal(this.props.data.bam_link_id)}
        >
          <img
            ref={node => this.addTooltip(node, 'edit-smartlink')}
            src={editSmartlinkIcon}
            alt="Edit Link"
          />
        </span>
      ) : null;

    if (columnObj.name === 'bam_link_merchant_product_name' || columnObj.name === 'product_name') {
      return (
        <div key={index} className={`column ${columnObj.name}`}>
          <p
            ref={node => {
              this.statTooltip = this.addTooltip(node, columnObj.name);
            }}
          >
            {columnContent}
          </p>
          {editSmartlink}
        </div>
      );
    }

    // Merchant table only fields
    if (columnObj.name === 'pricing_model') {
      return (
        <div key={index} className={`column ${columnObj.name}`}>
          <span className="value">{columnContent}</span>
          <span className={columnContent.toLowerCase()}>
            {columnContent === 'Narrativ' ? 'No Returns' : 'Returns Apply'}
          </span>
        </div>
      );
    }
    if (columnObj.name === 'attribution_model') {
      return (
        <div key={index} className={`column ${columnObj.name}`}>
          <span className={columnContent === 'Post Click' ? 'post-click' : ''}>
            {columnContent}
          </span>
        </div>
      );
    }
    if (columnObj.name === 'publisher_epc') {
      return (
        <div key={index} className={`column ${columnObj.name}`}>
          {columnContent}
          {badge}
        </div>
      );
    }

    // Merchant stories table
    if (this.props.statType === 'merchantArticle') {
      if (
        ((columnObj.name === 'click_through_rate' || columnObj.name === 'order_conversion_rate') &&
          this.props.data.clicks < 100) ||
        (columnObj.name === 'impressions' && !this.props.data.has_jstag)
      ) {
        return (
          <div
            key={index}
            className={`column ${columnObj.name} gray`}
            ref={node => {
              this.statTooltip = this.addTooltip(node, columnObj.name);
            }}
          >
            <p>{columnContent}</p>
          </div>
        );
      }
    }
    if (['merch-ed-overview', 'merchant-performance-overview'].includes(this.props.statType)) {
      if ('merchant_roi_goals' in this.props.data || 'roi_actual' in this.props.data) {
        if (columnObj.name === 'short_name') {
          const multipleGoals = this.props.data.merchant_roi_goals.length > 1;
          const roiReconIcon = this.props.data.is_reconciled ? (
            <div className="roi-rec-icon">ROI Rec</div>
          ) : null;

          const expandedIcon =
            multipleGoals && session.isAdminView ? (
              <span
                className={`${
                  this.props.expandedRowId === this.props.data.merch_id ? 'arrow-up' : 'arrow-down'
                }`}
              ></span>
            ) : null;

          const roiReconCheckbox =
            this.props.flags && this.props.flags.roiRecFeatures ? (
              <span
                className={getClass('checkbox', {
                  selected: this.props.roiReconSelections.includes(this.props.data.merch_id),
                })}
                onClick={e => {
                  if (e) e.stopPropagation();
                  this.props.updateRoiReconSelections(this.props.data.merch_id);
                }}
              ></span>
            ) : null;

          const addShadow = ['merch-ed-overview', 'merchant-performance-overview'].includes(
            this.props.statType,
          );

          return (
            <div
              key={index}
              className={getClass(`column ${columnObj.name}`, {
                'no-shadow': addShadow && !this.props.shadows.left,
              })}
              ref={node => {
                this.statTooltip = this.addTooltip(node, columnObj.name);
              }}
              onClick={
                multipleGoals && session.isAdminView
                  ? this.props.setRowId('expandedRowId', this.props.data.merch_id)
                  : null
              }
            >
              {roiReconCheckbox}
              <span className="content-icon">
                <Link
                  className={getClass({ 'faded-text': getRowClasses(this.props)['faded-text'] })}
                  to={`/v2/merchant/${this.props.data.merch_id}/desk`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {columnContent}
                </Link>
                {roiReconIcon}
              </span>
              {expandedIcon}
            </div>
          );
        }
        if (['daily_budget_amount', 'monthly_budget_amount'].includes(columnObj.name)) {
          let formHelper;
          let selected = false;
          const { budgetRowId } = this.props;
          if (budgetRowId) {
            const rowId = parseInt(budgetRowId.split(',')[0]);
            const budgetType = budgetRowId.split(',')[1];
            if (rowId === this.props.data.merch_id && budgetType === columnObj.name) {
              selected = true;
            }
            formHelper = selected ? (
              <FormHelper
                options={{
                  identifier: budgetType,
                  save: {
                    txt: 'Save',
                    callback: this.updateBudget.bind(this),
                  },
                  cancel: {
                    txt: 'Cancel',
                    callback: e => {
                      e.stopPropagation();
                      const target =
                        budgetType === 'monthly_budget_amount'
                          ? this.monthlyInputNode
                          : this.dailyInputNode;
                      target.value = formatValue(
                        parseFloat(this.props.data[budgetType]),
                        columnObj.type,
                        columnObj.name,
                        true,
                      );
                      this.props.setRowId('budgetRowId', null)();
                    },
                  },
                }}
                monthlyInputNode={this.monthlyInputNode}
                dailyInputNode={this.dailyInputNode}
              />
            ) : null;
          }

          const columnBudgetId = `${this.props.data.merch_id},${columnObj.name}`;

          return (
            <div
              key={index}
              className={getClass(`column ${columnObj.name}`, {
                'selected-budget': selected,
              })}
              ref={node => {
                this.statTooltip = this.addTooltip(node, columnObj.name);
              }}
              onClick={this.props.setRowId('budgetRowId', columnBudgetId)}
            >
              {formHelper}
              <div className="content">{columnContent}</div>
            </div>
          );
        }
        if (
          ['pacing_towards', 'reconciled_roi', 'roi_actual', 'budget_pacing'].includes(
            columnObj.name,
          )
        ) {
          let values;
          switch (columnObj.name) {
            case 'pacing_towards':
              values = [this.props.data.pacing_towards, this.props.data.monthly_budget_amount];
              break;
            case 'reconciled_roi':
              values = [this.props.data.reconciled_roi, this.props.data.target_roi];
              break;
            case 'roi_actual':
              values = this.formatRoiValues([this.props.data.roi_actual, this.props.data.roi_goal]);
              break;
            case 'budget_pacing':
              values = [
                formatCurrencyStringToNumber(this.props.data.budget_pacing),
                formatCurrencyStringToNumber(this.props.data.budget_amount),
              ];
              break;
            default:
              break;
          }

          let { color, icon } = getIntervalColorAndIcon(values, columnObj.name);

          if (columnObj.name === 'roi_actual') {
            if (
              !this.props.data.roi_actual ||
              this.props.data.roi_actual === '-' ||
              this.props.data.strategy_type === 'CPC'
            ) {
              icon = null;
              color = null;
            }
          }

          const hasBudget =
            this.props.data.budget_pacing &&
            this.props.data.budget_pacing !== '-' &&
            this.props.data.budget_amount &&
            this.props.data.budget_amount !== '-';

          if (columnObj.name === 'budget_pacing' && !hasBudget) {
            icon = null;
            color = null;
          }

          return (
            <div
              key={index}
              className={`column ${columnObj.name} ${color}`}
              ref={node => {
                this.statTooltip = this.addTooltip(node, columnObj.name);
              }}
            >
              <div className="content-icon">
                {columnContent}
                <img src={icon} alt={color} />
              </div>
            </div>
          );
        }
      }
    }

    // Bid Center Overview Tables
    if (
      this.props.statType === 'merchant-overview' &&
      ['daily_budget_amount', 'monthly_budget_amount'].includes(columnObj.name)
    ) {
      return (
        <div
          key={index}
          className={`column ${columnObj.name}`}
          ref={node => {
            this.statTooltip = this.addTooltip(node, columnObj.name);
          }}
        >
          {columnContent}
        </div>
      );
    }

    if (
      columnObj.name === 'recommended_product' &&
      this.props.statType === 'merchantRecommendation'
    ) {
      return (
        <div key={`recommended-${index}`} className={`column ${columnObj.name}`}>
          <div
            className={`checkbox ${this.props.checkboxClass}`}
            onClick={() => this.props.updateGraphedState(this.props.data)}
          />
          <p>{columnContent}</p>
          {newBadge}
        </div>
      );
    }

    if (columnObj.name !== 'edit_name') {
      const isNegative = this.props.data[columnObj.name] < 0;
      return (
        <div
          key={index}
          className={getClass(`column ${columnObj.name}`, {
            negative: isNegative,
            'no-shadow': !this.props.shadows.left,
          })}
        >
          <p>{columnContent}</p>
          {newBadge}
        </div>
      );
    }

    const row = this.props.data;
    const linkOutIcon = row.edit_url ? (
      <a
        className="link-out"
        href={row.edit_url}
        target="_blank"
        rel="noopener noreferrer"
        onClick={this.onEditUrlClicked.bind(this)}
      >
        <img ref={node => this.addTooltip(node, 'link-out')} src={linkoutIcon} alt="Open article" />
      </a>
    ) : null;
    const productPreview =
      this.props.statType === 'merchantArticleSearch' && this.state.showProductPreview ? (
        <ProductPreview
          data={this.props.data}
          reversed={
            this.editNode && this.editNode.getBoundingClientRect().bottom + 200 > window.innerHeight
          }
        />
      ) : null;

    const editName = row.edit_name || row.edit_url || '-';
    return (
      <div key={index} className={`column ${columnObj.name}`}>
        <div
          className={`checkbox ${this.props.checkboxClass}`}
          onClick={() => this.props.updateGraphedState(this.props.data)}
        />
        <p
          ref={node => {
            this.editNode = node;
            if (this.props.statType !== 'merchantArticleSearch') {
              this.statTooltip = this.addTooltip(node, 'smartlinks');
            }
          }}
          onMouseEnter={() => {
            this.setState({ showProductPreview: true });
          }}
          onMouseLeave={() => {
            this.setState({ showProductPreview: false });
          }}
        >
          <span
            className={this.disableLinks ? 'disabled-link' : 'article_name'}
            onClick={this.redirectToPage.bind(this)}
          >
            {this.props.statType === 'top-article' ? `${row.pub_name} | ${editName}` : editName}
          </span>
        </p>
        {badge}
        {linkOutIcon}
        {productPreview}
      </div>
    );
  }

  render() {
    return (
      <div
        className={getClass('stat-row', {
          hidden: this.props.hidden,
          ...(this.props.statType === 'merch-ed-overview' && getRowClasses(this.props)),
        })}
      >
        {this.props.columns.map((columnObj, index) => {
          return this.getColumnHtml(columnObj, index);
        })}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setSearchEdit: edit => dispatch(setSearchEdit(edit)),
  };
};

export default connect(null, mapDispatchToProps)(StatRow);
